"use client";
import { jsx as t } from "react/jsx-runtime";
import n from "./Popover.js";
import { usePopoverStyles as P } from "../../hooks/usePopoverStyles.js";
import { usePopperTransitions as f } from "../../hooks/usePopperTransitions.js";
import u from "../../../components/portal/Portal.js";
import { useState as v } from "react";
const c = ({
  children: e,
  feType: o,
  isHovered: p,
  triggerElement: s,
  ...l
}) => {
  const [r, m] = v(null), { styles: a, attributes: i } = P(o, {
    hoverElement: s,
    targetElement: r
  });
  return f(r, o), /* @__PURE__ */ t(u, { "data-portals": o, feRender: p, children: /* @__PURE__ */ t(
    n,
    {
      ...l,
      ...i.popper,
      feType: o,
      ref: m,
      style: a.popper,
      children: e
    }
  ) });
};
c.displayName = "PopoverPortal";
export {
  c as default
};
